import { cn } from "@simplicity/ui";
import { memo } from "react";
import { TypeBadge } from "../TypeBadge";
import type { TimelineRow } from "./layout";

export const TimelineRowView = memo(function TimelineRowView({
  row,
  showProjectName,
  onDotEnter,
  onDotLeave,
  hoveredDotKey,
  showFunction,
  onBarClick,
}: {
  row: TimelineRow;
  showProjectName: boolean;
  onDotEnter: (e: React.MouseEvent<HTMLDivElement>, dotKey: string, lines: string[]) => void;
  onDotLeave: () => void;
  hoveredDotKey: string | null;
  showFunction: boolean;
  onBarClick: (connectorRunId: number) => void;
}) {
  return (
    <tr>
      <td className="cell-project">{showProjectName ? row.projectName : ""}</td>
      <td className="cell-connector">
        <TypeBadge type={row.connectorType} />
      </td>
      {showFunction ? <td className="cell-function">{row.functionName}</td> : null}
      <td>
        <div className="timeline-axis">
          <div className="timeline-axis-line" />
          {row.bars.map((bar) => (
            // eslint-disable-next-line jsx-a11y/prefer-tag-over-role -- positioned visual bar segment inside the timeline grid; absolute positioning + hover-driven tooltip overlay would not survive being wrapped in a semantic <button>.
            <div
              role="button"
              tabIndex={0}
              key={bar.key}
              className={cn("tl-bar", bar.statusClass, hoveredDotKey === bar.key && "is-hovered")}
              // Dynamic-from-JS: bar position + width are percentages computed
              // from clamped timestamps in the layout pass. Keep inline.
              style={{ left: `${bar.centerPct}%`, width: `${bar.widthPct}%` }}
              onMouseEnter={(e) => onDotEnter(e, bar.key, bar.tooltipLines)}
              onMouseLeave={onDotLeave}
              onClick={() => onBarClick(bar.connectorRunId)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onBarClick(bar.connectorRunId);
                }
              }}
              aria-label={bar.tooltipLines.join(", ")}
            />
          ))}
        </div>
      </td>
    </tr>
  );
});
